import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { LocationWeatherForecastDto } from '../../../models/weather/dto/weather-forecast.dto';

export const GET_WEATHER_FORECAST_QUERY_KEY = (locationId: string) => [
  'weather',
  locationId,
];

export const useGetWeatherForecast = (locationId?: string) => {
  const apiClient = useApiClient();
  return useQuery({
    queryKey: GET_WEATHER_FORECAST_QUERY_KEY(locationId ?? ''),
    queryFn: () =>
      apiClient.fetchApi<LocationWeatherForecastDto, {}>({
        endpoint: `weather/${locationId}`,
        method: 'GET',
      }),
    enabled: !!locationId,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });
};
